<template>
  <div>

    <div class="row">
      <div class="col-md-6">
        <template v-if="getUser.role === 'owner'">
          <h5 class="mt-2">
            {{ meta.totalCount > 0 ? `Empresas cadastradas: ${meta.totalCount}` : 'Nenhuma empresa cadastrada' }}
          </h5>
        </template>
        <template v-else>
          <h5 class="mt-2">
            {{ meta.totalCount > 0 ? `Empresas cadastradas: ${meta.totalCount}` : 'Nenhuma empresa cadastrada ou você não possui acesso' }}
          </h5>
        </template>
      </div>
      <div class="col-md-6 text-right">
        <button @click="find(true)" class="btn btn-primary ml-4"><RefreshCcwIcon/></button>
        <router-link tag="button" to="definitions?tab=companies" class="btn btn-primary btn-xl ml-2">Ver todas</router-link>
      </div>
    </div>

    <table class="table table-borderless table-border table-align">
      <thead>
        <tr>
          <th>Razão Social</th>
          <th>CNPJ</th>
          <th>UF</th>
          <th>Filiais</th>
          <th>Criado por</th>
          <th>Certificado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="company in companies" :key="company.id">
          <td><strong>{{ company.name }}</strong></td>
          <td><strong>{{ company.cnpj | cnpj }}</strong></td>
          <td><strong>{{ company.uf }}</strong></td>
          <td><strong>{{ company.totalSubsidiaries }}</strong></td>
          <td><strong>{{ company.createdBy }}</strong></td>
          <td>
            <strong v-if="checkDate(company.certificateExpiringAt)">
              {{ company.certificateExpiringAt | certificate }}
            </strong>
            <strong v-else style="color: red">
              {{ company.certificateExpiringAt | certificate }}
            </strong>
          </td>
        </tr>
      </tbody>
    </table>

  </div>

</template>

<script>
  import EntityProxy from '@/models/EntityProxy'

  import GetAccount from '@/mixins/GetAccount.vue'
  import ModelMapper from '@/mixins/ModelMapper'
  import GetUser from '@/mixins/GetUser.vue';

  import { RefreshCcwIcon } from 'vue-feather-icons'

  export default {
    components: { RefreshCcwIcon },
    computed: {
      companies() {
        return this.getModels || []
      },
    },
    created() {
      this.query.root = true
      this.methods.push('total_subsidiaries')
      this.addOrderBy('created_at')
      this.find()
    },
    data() {
      return {
        nameModel: 'Company'
      }
    },
    methods: {
      checkDate(string) {
        if (string) {
          const date = new Date(string)
          return date > new Date()
        }
      },
      find(force) {
        const key = this.$name()

        const data = this.$ls.get(key)
        if (!force && data) {
          this.setModels(EntityProxy.build(data.companies))
          this.setMeta(EntityProxy.build(data.meta))
          return
        }

        this.asyncTemplateSelect({
          after: ({ models, meta }) => this.$ls.set(key, { companies: models, meta: meta }, { minutes: 10 })
        })
      }
    },
    mixins: [ModelMapper, GetAccount, GetUser],
    name: 'DashboardCompany'
  }
</script>

<style scoped>

</style>
